import { createBrowserRouter } from "react-router-dom";
import Login from "./pages/Login";
import DashboardLayout from "./layout/DashboardLayout";

import Overview from "./pages/Overview";
import UsersPage from "./pages/UsersPage";
import ClientsPage from "./pages/ClientsPage";
import SessionsPage from "./pages/SessionsPage";

export const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  {
    path: "/",
    element: (
      // Wrap the Layout! If user is null, ProtectedRoute redirects
        <DashboardLayout />
    ),
    children: [
      { index: true, element: <Overview /> },
      { path: "users", element: <UsersPage /> },
      { path: "clients", element: <ClientsPage /> },
      { path: "sessions", element: <SessionsPage /> },
    ],
  },
  { path: "*", element: <div>Not Found</div> },
]);